// extracted by mini-css-extract-plugin
export default {"wrapper":"dR6t4","picture":"AjpAe","content":"yVWhv","title":"atwQW","subtitle":"TGzun","button":"RxFNl"};